<template>
  <section class="event-card">
    <div class="itemLive">
      <a
        class="offline-course-card"
        :href="'/live/liveDetail?id=' + item.id"
        target="_blank;"
      >
        <div class="left">
          <span class="status status-notstarted" v-if="item.liveStatus == 2">{{
            $t("live.即将开始")
          }}</span>
          <span class="status status-living" v-if="item.liveStatus == 1">
            <img src="/static/icon_app_live_on_white.gif" alt />
            {{ $t("live.直播中") }}
          </span>
          <span class="status status-closed" v-if="item.liveStatus == 3">{{
            $t("global.已结束")
          }}</span>
          <img :src="item.horizontalThumb | imageUrl('', 350, 197)" />
          <div class="popIntroduction">
            <p class="introduction">{{ item.intro }}</p>
          </div>
        </div>
        <div class="right">
          <h5>{{ item.title }}</h5>
          <div class="sub-title">
            <div class="guest" v-for="(index, y) in item.guestForms" :key="y">
              <router-link
                :to="'/peopleCenter/' + index.userId + '/home'"
                v-if="index.userId"
                target="_blank"
                >{{ index.nickName }}</router-link
              >
              <span v-if="!index.userId">{{ index.nickName }}</span>
              <i></i>
            </div>
          </div>
          <p class="begin-time">{{ formatDate(item.liveStartTime, 1) }}</p>
          <p class="info">
            <span v-if="item.price > 0" class="price">
              <b>￥{{ item.price }}</b>
            </span>
            <span v-if="item.price == 0 || item.price == null" class="free">
              <b>{{ $t("global.免费") }}</b>
            </span>
          </p>
          <div v-if="item.liveStatus == 2">
            <span
              class="liveStatus status_4"
              @click.stop.prevent="closeSub(item.id)"
              v-if="item.isSub"
            >
              <i class="hover1">{{ $t("global.已订阅") }}</i>
              <i class="hover2">{{ $t("live.取消订阅") }}</i>
            </span>
            <el-popover placement="bottom" width="175px" trigger="hover" v-else>
              <div class="tixing">
                {{ $t("live.开播前短信/服务号/App通知") }}
              </div>
              <span
                class="liveStatus status_1"
                slot="reference"
                @click.stop.prevent="subscribe(item.id)"
              >
                <img src="/static/web_live_notif_icon@2x.png" alt />
                {{ $t("live.订阅") }}
              </span>
            </el-popover>
          </div>
          <span
            class="liveStatus status_2"
            v-if="item.liveStatus == 1"
            @click.stop.prevent="gotolivePage(item.activityId)"
            >{{ $t("live.进入直播间") }}</span
          >
          <span
            class="liveStatus status_3"
            @click.stop.prevent="gotolivePage(item.activityId)"
            v-if="item.liveStatus == 3"
            >{{ $t("live.进入回看") }}</span
          >
        </div>
      </a>
    </div>
    <div class="popup" v-if="isPopupShow">
      <div class="popupBox" v-if="subTer">
        <p class="title">
          {{ $t("live.订阅直播") }}
          <span @click="closePopup"></span>
        </p>
        <p class="line"></p>
        <img class="subImg" src="/static/img_subscribed@2x.png" alt />
        <p class="text">
          {{
            $t(
              "live.您已成功订阅直播提醒，直播开始前15分钟将通过短信、服务号及App推送通知。"
            )
          }}
        </p>
      </div>
      <div class="popupBox" v-else>
        <p class="title">
          {{ $t("live.取消订阅成功") }}
          <span @click="closePopup"></span>
        </p>
        <p class="line"></p>
        <img class="subImg" src="/static/img_unsubscribed@2x.png" alt />
        <p class="text">
          {{
            $t("live.您已成功取消订阅直播提醒，将不再收到该直播开始的通知。")
          }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      isPopupShow: false,
      subTer: true,
    };
  },
  methods: {
    gotolivePage(id) {
      if (id) {
        let routeData = this.$router.resolve({
          path: "/live/livePage?id=" + id,
        });
        window.open(routeData.href, "_blank");
        // this.$router.push("/live/livePage?id=" + id);
      }
    },
    subscribe(id) {
      this.subTer = true;
      this.$http.get("/api/bytedance/sub/" + id).then((res) => {
        if (res.code === "OK") {
          document.body.style.overflow = "hidden";
          this.isPopupShow = true;
          this.$emit("refresh");
        }
      });
    },
    closeSub(id) {
      this.subTer = false;
      this.$http.get("/api/bytedance/unsub/" + id).then((res) => {
        if (res.code === "OK") {
          document.body.style.overflow = "hidden";
          this.isPopupShow = true;
          this.$emit("refresh");
        }
      });
    },
    closePopup() {
      document.body.style.overflow = "";
      this.isPopupShow = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.itemLive {
  width: 350px;
  margin: 0 30px 60px 0;
  height: 362px;
  border: 1px solid rgba(224, 224, 224, 1);
  box-sizing: border-box;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;

  &:nth-child(2) {
    margin-right: 0;
  }

  .offline-course-card {
    display: block;
    position: relative;
    background: #fff;

    .left {
      position: relative;
      width: 100%;
      height: 197px;

      img {
        width: 100%;
        height: 197px;
      }

      .popIntroduction {
        positioN: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(10, 10, 10, 0.7);
        display: none;

        .introduction {
          position: absolute;
          max-height: 60px;
          font-size: 13px;
          font-family: NunitoSans-Regular, NunitoSans;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 20px;
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;
          left: 0;
          bottom: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          word-break: break-word;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
      }

      .status {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 0 12px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background-size: 100%;
        font-size: 13px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        z-index: 111;
        border-radius: 0px 4px 0px 0px;
      }

      .status-notstarted {
        background: linear-gradient(135deg, rgba(54, 100, 237, 0.9) 0%, rgba(32, 38, 204, 0.9) 100%);
      }

      .status-living {
        background: linear-gradient(135deg, rgba(254, 161, 116, 0.9) 0%, rgba(254, 86, 48, 0.9) 100%);

        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          vertical-align: text-top;
          margin-right: 4px;
        }
      }

      .status-closed {
        background: linear-gradient(135deg, rgba(204, 204, 204, 0.9) 0%, rgba(153, 153, 153, 0.9) 100%);
      }
    }

    .right {
      height: 165px;
      padding: 12px 20px 20px;
      box-sizing: border-box;

      h5 {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 42px;
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(10, 10, 10, 1);
        line-height: 21px;
        word-break: break-word;
      }

      .sub-title {
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 10px;

        .guest {
          display: inline;

          &:last-child {
            i {
              display: none;
            }
          }

          a {
            color: #666;

            &:hover {
              color: #0A0A0A;
            }
          }

          span {
            color: #999;
          }

          i {
            background: rgba(184, 184, 184, 1);
            display: inline-block;
            width: 3px;
            height: 3px;
            margin-right: 3px;
            border-radius: 50%;
            vertical-align: middle;
          }
        }
      }

      .begin-time {
        margin-top: 12px;
        font-size: 13px;
        font-family: NunitoSans-Regular, NunitoSans;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }

      .begin-time-expired {
        color: #999;
      }

      .info {
        margin-top: 10px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        color: rgba(252, 98, 64, 1);

        .price {
          font-weight: 400;
          font-size: 16px;
        }

        .free {
          font-weight: 600;
          font-size: 16px;
        }
      }

      .btn-wrap {
        position: absolute;
        right: 0;
        bottom: 0;
        text-align: right;

        .btn {
          display: inline-block;
          width: 90px;
          height: 34px;
          background: #3664ED;
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          line-height: 34px;
          border-radius: 20px;
        }

        .btn-disable {
          background: #eee;
          color: #999;
        }
      }

      .liveStatus {
        position: absolute;
        right: 20px;
        bottom: 20px;
        height: 28px;
        line-height: 28px;
        min-width: 108px;
        text-align: center;
      }

      .status_1 {
        min-width: 88px;
        border: 1px solid rgba(32, 38, 204, 1);
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(32, 38, 204, 1);

        img {
          display: inline-block;
          width: 14px;
          height: 14px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      .status_2, .status_3 {
        border: 1px solid rgba(32, 38, 204, 1);
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(32, 38, 204, 1);

        img {
          display: inline-block;
          width: 10px;
          height: 16px;
          vertical-align: middle;
          margin-left: 5px;
        }
      }

      .status_4 {
        min-width: 90px;
        border: 1px solid rgba(184, 184, 184, 1);
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(184, 184, 184, 1);

        .hover2 {
          display: none;
        }

        &:hover .hover2 {
          display: block;
        }

        &:hover .hover1 {
          display: none;
        }
      }
    }
  }

  &:hover {
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);

    .offline-course-card .left .popIntroduction {
      display: block;
    }
  }

  &:nth-child(3n) {
    margin-right: 0;
  }
}

.popup {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;

  .popupBox {
    width: 380px;
    height: 240px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
      position: relative;

      span {
        background: url('/static/close_btn@2x.png');
        background-size: 100%;
        width: 13px;
        height: 13px;
        position: absolute;
        right: 20px;
        top: 23px;
        cursor: pointer;
      }
    }

    .line {
      height: 1px;
      width: 100%;
      background: #E0E0E0;
    }

    .subImg {
      display: inline-block;
      width: 64px;
      height: 64px;
      margin: 15px 158px;
    }

    .text {
      height: 48px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 24px;
      padding: 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/peopleCenter/LiveCard.vue